import { runScript } from './run-script.js'

export async function injectHtml(parentEl: HTMLElement | DocumentFragment, html: string) {
  const divEl: HTMLDivElement = document.createElement('div')
  divEl.innerHTML = html

  // need to run these sequentially since there may be dependencies
  for (const scriptEl of divEl.querySelectorAll('script')) {
    await runScript(scriptEl)
  }

  for (const styleEl of divEl.querySelectorAll('style')) {
    document.body.append(styleEl)
  }

  while (divEl.firstChild) {
    parentEl.append(divEl.firstChild)
  }
}
